import axios from 'axios'

const baseURL = `${process.env.VUE_APP_NEW_API_URL}`

export default {
  async fetch(limit, page, search, masterId, agentId) {
    try {
      return axios.get(
        `${baseURL}/notification?limit=${limit}&page=${page}&search=${search}&agentId=${agentId}&masterId=${masterId}`
      )
    } catch (e) {
      throw e
    }
  },
  async create(data) {
    try {
      return axios.post(`${baseURL}/notification`, data)
    } catch (e) {
      throw e
    }
  },
  async delete(id) {
    try {
      return axios.delete(`${baseURL}/notification/${id}`)
    } catch (e) {
      throw e
    }
  },
  async findById(id) {
    try {
      return axios.get(
        `${baseURL}/notification/${id}`
      )
    } catch (e) {
      throw e
    }
  },
  async update(id, data) {
    try {
      return axios.put(`${baseURL}/notification/${id}`, data)
    } catch (e) {
      throw e
    }
  },
}
